<!--
 * @Author: your name
 * @Date: 2021-08-28 17:10:46
 * @LastEditTime: 2021-09-25 21:58:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-hero-bump-website-front\src\components\footer.vue
-->
<template>
  <footer>
    <div class="triangle" @click="BtoTop" v-if="!mobile">
      <div class="small"></div>
      <div class="back">{{ $t('top') }}</div>
    </div>
    <div class="bottom">
      <div class="download" v-if="mobile">
        <a href="../assets/apple.png" class="apple"></a>
        <a href="../assets/google.png" class="google"></a>
      </div>
      <div class="line" v-if="mobile"></div>
      <div class="footer">
        <div class="left"></div>
        <div class="right">
          <p class="top">
            <a class="add-text mr30" :href="fwtk" target="_blank">【{{ $t('service') }}】</a>
            <a class="add-text" :href="yszc" target="_blank">【{{ $t('privacy') }}】</a>
          </p>
          <p class="footer-line2">
            Copyright © Orienjoy International Company Limited.All rights
            reserverd.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { userAgent } from '../utils/index.js'
export default {
  data () {
    return {
      scrolled: false,
      limitHeight: 300,
      fwtk: window.location.origin + '/fwtk',
      yszc: window.location.origin + '/yszc'

    }
  },
  mounted () {
    document.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    mobile () {
      return userAgent().mobile
    }
  },
  methods: {
    handleScroll () {
      this.scrolled = window.scrollY < this.limitHeight
    },
    BtoTop () {
      var time = ''
      if (this.scrolled === false) {
        time = setInterval(function () {
          var ispeed = Math.floor(-window.scrollY / 10)
          document.documentElement.scrollTop = document.body.scrollTop =
            window.scrollY + ispeed
          if (window.scrollY === 0) {
            clearInterval(time)
          }
        }, 30)
      } else {
        clearInterval(time)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../styles/mixin.less");
.add-text{
  text-decoration-line: none;
  color:  #616161;
  &:hover{
    color: #c6c6c6;
  }
}
footer {
  width: 100%;
  position: relative;
  .triangle {
    position: absolute;
    width: 0;
    height: 0;
    top: -130px;
    left: 50%;
    transform: translate(-50%,0);
    margin: 0 auto;
    border: 80px solid transparent;
    border-bottom: 50px solid #222;
    .flex(@around);
    flex-direction: column;
    cursor: pointer;
    &:hover .small {
      border-bottom: 12px solid #ffde00;
    }
    &:hover .back {
      color:  #ffde00;
    }
    .small {
      width: 0;
      height: 0;
      padding: 15px 0;
      border: 20px solid transparent;
      border-bottom: 12px solid #bda60a;
    }
    .back {
      color: #bda60a;
      width: 50px;
      font-size: 14px;
      margin: 10px 0 0 0;
    }
  }
  .bottom {
    height: 150px;
    background-color: #222;
    position: relative;
    color: #c6c6c6;
    .footer {
      width: 60%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: 120px;
      .flex(@center);
    }
    .left {
      margin-right: 80px;
      width: 231px;
      height: 83px;
      background: url("../assets/logo2.png") no-repeat;
      background-size: 100%;
    }
  }
  .footer-line2{
    font-size: 16px;
    margin-top: 10px;
  }
}

@media screen and (max-width: 750px) {
  footer {
    width: 100%;
    font-size: 0.2rem;
    position: relative;
    .triangle {
      width: 0;
      height: 0;
      margin: 0 auto;
      border: none;
      border-bottom: none;
      .flex(@around);
      flex-direction: column;
      cursor: pointer;
      &:hover .small {
        border-bottom: 12px solid #ffde00;
      }
      &:hover .back {
        color:  #ffde00;
      }
      .small {
        width: 0;
        height: 0;
        padding: 15px 0;
        border: 20px solid transparent;
        border-bottom: 12px solid #bda60a;
      }
      .back {
        color: #bda60a;
        width: 50px;
        font-size: 14px;
        margin: 10px 0 0 0;
      }
    }
    .line{
      width: 6.9rem;
      border-bottom: 0.01rem solid #808080;
      margin:0 auto;
      margin-top: 0.5rem;
    }
    .download {
      position: relative;
      top: 0.2rem;
      width: 7.2rem;
      left: 50%;
      transform: translate(-50%, 0);
      padding-top: 0.2rem;
      .flex(@around);
      a {
        width: 2.68rem;
        height: 0.8rem;
        &.apple {
          background: url("../assets/apple.png") no-repeat;
          background-size: 100%;
        }
        &.google {
          background: url("../assets/google.png") no-repeat;
          background-size: 100%;
        }
      }
    }
    .bottom {
      height: 4.4rem;
      background-color: #222;
      color: #c6c6c6;
      .footer {
        width: 90%;
        position: absolute;
        left: 0;
        top: 1.4rem;
        bottom: 0;
        right: 0;
        margin: auto;
        height: 2.8rem;
        .flex(@center);
        flex-direction: column;
      }
      .left {
        margin-right: 0;
        // margin-bottom: 0.32rem;
        width: 2.31rem;
        height: 0.74rem;
        background: url("../assets/logo2.png") no-repeat;
        background-size: 100%;
      }
      p {
        margin-top: 0.24rem;
      }
    }
  }
}
</style>
